import React from 'react';
import { useTranslation } from 'next-i18next';
import classnames from 'classnames';

import { TestimonialsCarousel } from '@components/testimonials';
import { isArrayEmpty } from '@helpers/ArrayHelpers';

import type { ITestimonial } from 'types';

import styles from './TestimonialsSlot.module.scss';

interface Props {
  className?: string,
  //
  title: string,
  description: string,
  //
  testimonials: ITestimonial[],
  //
  dataTestId: string
}

const TestimonialsSlot = (props: Props) => {

  const {
    className,
    //
    title,
    description,
    //
    testimonials,
    //
    dataTestId,
  } = props;

  // Hooks

  const { t } = useTranslation();

  // Empty

  if (isArrayEmpty(testimonials, true)) {
    return null;
  }

  // Render

  return (
    <div
      className={classnames(styles.root, className)}
      data-test-id={dataTestId}
    >

      {/* Title */}
      <div className={styles.title}>{title || t('HOMEPAGE.TESTIMONIALS_SLOT.TITLE')}</div>

      {/* Description */}
      <div className={styles.description}>{description || t('HOMEPAGE.TESTIMONIALS_SLOT.DESCRIPTION')}</div>

      {/* Carousel */}
      <div className={styles.carouselWrapper}>
        <TestimonialsCarousel testimonials={testimonials} />
      </div>

    </div>
  );
};

// Export

export default TestimonialsSlot;
